'use strict';

class SmsAuthView {

    constructor() {

        this._errors = {
            'locked': 'Вы были заблокированы, попробуйте позднее.',
            'invalid_phone': 'Введите номер телефона в правильном формате.',
            'code_exists': 'Получение кода временно не доступно.',
            'user_not_exists': 'Пользователь не существует.',
            'create_code_error': 'Ошибка создания кода.',
            'create_user_error': 'Ошибка создания пользователя.',
            'no_match': 'Код не совпал.',
            'code_is_lost': 'Срок действия кода истек.',
            'no_agree': 'Вы должны принять согласие на обработку персональных данных.',
        };

    }

    getInsertPhoneForm(data = {}) {

        let {
            action = '',
            error = '',
        } = data;

        return `
        <form class="sms-auth"
            method="GET"
            action="${action}"
            onsubmit="smsAuth.getCode(this.phone.value, this.i_agree.checked);return false;">
            <div class="title"><span>Вход</span> / регистрация</div>
            <p>Введите номер телефона</p>
            ${this._getErrorMessage(error)}
            <input class="phone"
                name="phone"
                data-pattern-vars="{_: '\\\\d'}"
                placeholder="+7 (___) ___-__-__"
                type="text" />
            <br>
            <div class="sign">
            <input class="input-aut" type="checkbox" id="auth_i-agree" name="i_agree" required />
            <label class="label-aut" for="auth_i-agree">
                Согласие на обработку персональных данных
                (<a target="_blank" href="/Obrabotka-personalnih-dannih">текст</a>).
            </label>
            </div>

            <button class="send-button">Получить код</button>

        </form>
        `;

    }

    getInsertCodeForm(data = {}) {

        let {
            action = '',
            error = '',
        } = data;

        return `
        <form class="sms-auth"
            action="${action}"
            onsubmit="smsAuth.verifyCode(this.code.value);return false;">
            <div class="title"><span>Вход</span> / регистрация</div>
            <p>Введите код из СМС</p>
            ${this._getErrorMessage(error)}
            <input class="code-sms" name="code" type="text" placeholder="XXXXXX" />
            <button class="send-button">Войти в личный кабинет</button>

        </form>
        `;

    }

    getLostCodeView(data = {}) {

        let {

            action = '',
            error = '',

        } = data;

        return `
        <div class="sms-auth">
            <div class="title"><span>Вход</span> / регистрация</div>
            <div class="success">
                ${this._getErrorMessage(error)}
                <a href="${action}"
                    onclick="smsAuth.getCodeRetry(); return false;">
                    Получить код повторно
                </a>
            </div>
        </div>
        `;

    }

    getSuccessView() {

        return `
        <div class="sms-auth">
            <div class="title"><span>Вход</span> / регистрация</div>
            <div class="success">
                Вход выполнен успешно.
            </div>
        </div>
        `;

    }

    _getErrorMessage(error = '') {

        if (!error) return '';
        return `<div class="error-msg">${this._errors[error]}</div>`;

    }

}

const smsAuthView = new SmsAuthView;
